import {
    VALIDATE_OTP_REQUEST,
    VALIDATE_OTP_SUCCESS,
    VALIDATE_OTP_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const validateOtpReducer = (state = initialState, action) => {
    switch (action.type) {
        case VALIDATE_OTP_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case VALIDATE_OTP_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case VALIDATE_OTP_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default validateOtpReducer;
